import React from 'react';
import { cn } from '../../../lib/utils';

// Entrance stagger for admin panels. splitfin-manager does this with motion;
// here it is a CSS keyframe (`animate-rise` in tailwind.config.js), which
// renders reliably in throttled screenshot tabs.
export const Reveal: React.FC<{ index?: number; className?: string; id?: string; children: React.ReactNode }> = ({ index = 0, className, id, children }) => (
  <div id={id} className={cn('motion-safe:animate-rise', className)} style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}>
    {children}
  </div>
);
